import { put } from 'redux-saga/effects';
import importer from 'common/importer';

const { mulesoft } = importer('APIs/auth', null);
const { verifyToken: resetPassword2, resetOktaPassword: resetPassword3 } =
	mulesoft;

const UserActions = importer('Stores/Users/Actions');

export default function* main({ token }) {
	try {
		yield put(UserActions.resetPassword2Loading());
		const verifyToken = yield resetPassword2(token);
		const stateToken = verifyToken?.data?.data?.stateToken;
		const userInfo = verifyToken?.data?.data;
		// Storing only the stateToken in global state returned from /verify-token call to be used in next /reset-password call on submission of new password form
		yield put(UserActions.resetPassword2Success({ stateToken, userInfo }));
	} catch (error) {
		yield put(UserActions.resetPassword2Failure(error));
	}
}
